var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view kef-export-order" }, [
    _c(
      "div",
      { staticClass: "main-contain" },
      [
        _c(
          "el-form",
          {
            staticClass: "section",
            attrs: {
              "label-position": "right",
              "label-width": "120px",
              "label-suffix": ":"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ExportSettings")))
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SystemDocking.BusinessType") } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.type,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "line-height": "28px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "font-size": "14px",
                                  "margin-right": "5px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemDocking.OceanFreight"))
                                )
                              ]
                            ),
                            _c("el-radio", { attrs: { label: "SE" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("SystemDocking.OceanExport"))
                              )
                            ]),
                            _c("el-radio", { attrs: { label: "SI" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemDocking.OceanImportdirectOrder")
                                )
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "line-height": "28px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "font-size": "14px",
                                  "margin-right": "5px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemDocking.AirFreight"))
                                )
                              ]
                            ),
                            _c("el-radio", { attrs: { label: "AE" } }, [
                              _vm._v(_vm._s(_vm.$t("SystemDocking.AirExport")))
                            ]),
                            _c("el-radio", { attrs: { label: "AI" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemDocking.AirImportdirectOrder")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ExportConditions")))
                ]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 18 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.BusinessDate")
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.form.EtdDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "EtdDate", $$v)
                                    },
                                    expression: "form.EtdDate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.OperationDate")
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.form.customDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "customDate", $$v)
                                    },
                                    expression: "form.customDate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 18 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemDocking.BusinessCreationDate"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.form.dateCreated,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "dateCreated", $$v)
                                    },
                                    expression: "form.dateCreated"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.BusinessStatus")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { multiple: "" },
                                    model: {
                                      value: _vm.form.jobState,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "jobState", $$v)
                                      },
                                      expression: "form.jobState"
                                    }
                                  },
                                  _vm._l(_vm.jobState, function(state) {
                                    return _c("el-option", {
                                      key: state.code,
                                      attrs: {
                                        label: state.chineseName,
                                        value: state.code
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 18 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.Operation")
                                }
                              },
                              [
                                _c("cargo-user-select", {
                                  attrs: {
                                    "method-params": {
                                      category: "role",
                                      shape: "op"
                                    },
                                    "default-value": _vm.form.operatorId
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.form.operatorId = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.BusinessNumber")
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.jobNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "jobNo", $$v)
                                    },
                                    expression: "form.jobNo"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 18 } },
                      [
                        _vm.form.type === "AE" || _vm.form.type === "SE"
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SystemDocking.DirectOrder")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.mblOnly,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "mblOnly", $$v)
                                          },
                                          expression: "form.mblOnly"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SystemDocking.All")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SystemDocking.Yes")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("SystemDocking.No"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemDocking.OperatingBranch")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Office,
                                    multiple: "",
                                    "default-multiple-value": _vm.form.branchId
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.branchId = [].concat(
                                        p.value
                                      ))
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemDocking.MasterBillNumber"
                                  )
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.mbl,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "mbl", $$v)
                                    },
                                    expression: "form.mbl"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.form.type === "SE" || _vm.form.type === "SI"
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemDocking.MasterBillSerialNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.form.serialNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "serialNo", $$v)
                                        },
                                        expression: "form.serialNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c("el-form-item", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("span", { staticClass: "orange" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemDocking.ReminderExportedAtOnce1000"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleExport }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemDocking.ConfirmExport")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }